import(/* webpackMode: "eager", webpackExports: ["ContainerComponent"] */ "/usr/share/nginx/html/pwatools/core/general/container/container.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/menubuilder/search/searchShortcut.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/navigation/NotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/adsWidget.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/bannerSlider.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/bannerSwiper.component.tsx");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/core/widget/component/widgetTitleBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/favoriteWidget.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/horizontalWidget.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/mediaSwiper.component.tsx");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/core/widget/providerContainer.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/shortcut/toolsShortcutContainer.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShortcutSquareSwiperComponent"] */ "/usr/share/nginx/html/pwatools/core/widget/shortcutSquareSwiper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShortcutSwiperComponent"] */ "/usr/share/nginx/html/pwatools/core/widget/shortcutSwiper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/shortVideoSwiper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoGardiGenreSwiperComponent"] */ "/usr/share/nginx/html/pwatools/core/widget/videoGardiGenreSwiper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoGardiSwiperComponent"] */ "/usr/share/nginx/html/pwatools/core/widget/videoGardiSwiper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/widget/walletWidget.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/next/dist/client/image-component.js");
